import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconReminderTrue$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconReminderTrue extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '06de322d191e71ee1b758fc0ba816de4c6b06af7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '15c2b02f01a7e736837dfb22a263a806639bff39', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7d577b71de66760bae0316b731bbca73146edcc1', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 3C7 3 5.1 6.05 5.1 9.57a10.7 10.7 0 0 1-1.1 4.7.49.49 0 0 0 .44.72h13.1a.5.5 0 0 0 .45-.72 10.5 10.5 0 0 1-1.06-4.64C16.93 6.12 14.66 3 11 3m0 1.5h.019c-4.06.014-4.379 3.882-4.379 5.07A12.3 12.3 0 0 1 6 13.49h10.05a12.3 12.3 0 0 1-.63-3.86c0-2.545-1.514-5.119-4.401-5.13h.021zM8.547 17.28A.51.51 0 0 1 9 17h4a.51.51 0 0 1 .36.81 3 3 0 0 1-4.77 0 .51.51 0 0 1-.043-.53", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-reminder-true", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-reminder-true"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-reminder-true":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconReminderTrue$1);
            }
            break;
    } });
}

const CosmosIconReminderTrue = CosmosIconReminderTrue$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconReminderTrue, defineCustomElement };
